import { useContext, type ReactNode } from 'react';

import { SankeyGraphArea } from './components/SankeyGraphArea.js';
import { SankeyDataContext } from './context/SankeyData.context.js';
import { getSankeyIsEmpty } from './utils/get-sankey-is-empty.js';
import { ChartLayout } from '../core/components/chart-layout/ChartLayout.js';
import { getChartStatesTemplates } from '../core/components/chart-states/utils/get-chart-states-template.js';

interface SankeyChartLayoutProps {
  chartWidth?: number | string;
  chartHeight?: number | string;
  showLoader: boolean;
  children?: ReactNode;
}

export function SankeyChartLayout({
  chartWidth,
  chartHeight,
  showLoader,
  children,
}: SankeyChartLayoutProps) {
  const graph = useContext(SankeyDataContext);
  const isEmpty = getSankeyIsEmpty(graph);
  const { emptyState, errorState } = getChartStatesTemplates(children);

  return (
    <ChartLayout
      chartWidth={chartWidth}
      chartHeight={chartHeight}
      isEmpty={isEmpty}
      emptyState={emptyState}
      errorState={errorState}
      showLoader={showLoader}
    >
      <ChartLayout.Graph>
        <SankeyGraphArea />
      </ChartLayout.Graph>
    </ChartLayout>
  );
}
